export interface DynamicAsset {
    Id: number;
    Name:  string;
    Description: string;
    Location: string;
    WebPictureId: string;
    MobilePictureId: string;
    DateCreatedUtc: string;
    CreatedByUserId: string;
}

export class CreateDynamicAsset {
    public Name: string;
    public Description: string;
    public Location: string;
    public WebPictureId: string;
    public MobilePictureId: string;
}

export class EditDynamicAsset extends CreateDynamicAsset {
    Id;
    public Name: string;
    public Description: string;
    public Location: string;
    public WebPictureId: string;
    public MobilePictureId: string;
    constructor(asset: DynamicAsset){
        super();
        this.Id = asset.Id;
        this.Name = asset.Name;
        this.Description = asset.Description;
        this.Location = asset.Location;
        this.WebPictureId = asset.WebPictureId;
        this.MobilePictureId = asset.MobilePictureId;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/inModels/DynamicAsset.ts